import React from 'react';
import { twMerge } from 'tailwind-merge';

const AnalyticWidget = ({ title, monthTotal, total, percent, loading }) => {
  if (loading) {
    return (
      <div className="border p-4 xl:p-6 grid gap-6 animate-pulse">
        <div className="grid">
          <div className="h-6 md:h-8 lg:h-10 bg-gray-300"></div>
          <div className="h-4 bg-gray-300 mt-2"></div>
        </div>
        <div className="grid grid-cols-2 justify-between">
          <div className="grid gap-2">
            <div className="h-5 md:h-6 bg-gray-300 "></div>
            <div className="h-4 bg-gray-300 "></div>
          </div>
          <div className="flex items-center justify-end">
            <div className="h-6 md:h-8 bg-gray-300 rounded w-1/2"></div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="border p-4 xl:p-6 grid gap-4 md:gap-6">
        <div className="grid gap-2">
          <div className="flex items-center gap-3">
            <div className="text-base md:text-lg lg:text-2xl font-header2">{total}</div>
          </div>
          <div className="text-xs md:text-base">{title}</div>
        </div>
        <div className="grid grid-cols-2 justify-between ">
          <div className="grid">
            <div className="text-sm md:text-lg">{monthTotal}</div>
            <div className="text-xs text-gray-600">За місяць</div>
          </div>
          <div className="flex items-center justify-end">
            <div className={twMerge(percent >= 0 ? 'text-lime-700' : 'text-red-700', 'text-sm md:text-2xl')}>
              {percent >= 0 ? `+${percent}` : percent}%
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default AnalyticWidget;
